import { render, staticRenderFns } from "./AddDiscountModal.vue?vue&type=template&id=a620a79a&scoped=true"
import script from "./AddDiscountModal.vue?vue&type=script&lang=js"
export * from "./AddDiscountModal.vue?vue&type=script&lang=js"
import style0 from "./AddDiscountModal.vue?vue&type=style&index=0&id=a620a79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a620a79a",
  null
  
)

export default component.exports